/**
 * 搜索和分类专用
 */
import { add } from '@/util/url';
import { delay } from '@/util/common';

export function toSearchPage(params = {}) {
  try {
    params.t1 = Date.now();
  } catch (error) {
    console.log(error);
  }
  const url = add(`${window.location.origin + window.location.pathname}`, params);
  delay(() => {
    window.location.href = `${url}#/search`;
  }, 200);
}

export function searchTrim(str) {
  if (str) {
    str = str.replace(/ /g, '');
  }
  return str;
}
